import { Config } from "./config";

const AttemptResource = {
    base: "/api/custom/school/attempt",
    fetch(criteria, callback) {
        Config.Connection()
            .post(`${this.base}/find`, criteria)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    create(data, callback) {
        Config.Connection()
            .post(this.base, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    update(data, callback) {
        Config.Connection()
            .put(this.base, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    submit(data, callback) {
        Config.Connection()
            .put(`${this.base}/submit`, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    get(id, callback) {
        Config.Connection()
            .get(`${this.base}/${id}`)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    open(id, callback) {
        Config.Connection()
            .get(`${this.base}/open/${id}`)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    syncReponse(data, callback) {
        Config.Connection()
            .put(`${this.base}-question/response`, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    },
    updateQuestion(data, callback) {
        Config.Connection()
            .put(`${this.base}-question/response`, data)
            .then(resp => callback(resp.data))
            .catch(err => callback(err.response?.data));
    }
};

export default AttemptResource;